export const QUERY_DIRECTORY = `${process.cwd()}/server/queries`;
export const PERSISTED_DIRECTORY = `${process.cwd()}/server/persisted`;
export const QUERY_HISTORY_FILE = `${process.cwd()}/server/history/query-history.json`;
export const PERSISTED_HISTORY_FILE = `${process.cwd()}/server/history/persisted-history.json`;
